import { CardFieldHandle, type CardFieldEvents, type CardFieldMountOptions } from './card-field';
import { MentaError, type MentaErrorCode } from './errors';
import { FieldsController } from './fields';
import type { InstallmentPlan, InstallmentsCard, InstallmentsError, InstallmentsResult } from './installments';
import { Menta, type MentaConstructorOptions } from './menta';
import type { FieldStyle, FieldStyleByState, IframeTheme } from './transport/iframe';
import type { FieldName } from '../protocol';

export { Menta, CardFieldHandle, FieldsController, MentaError };
export type {
  CardFieldEvents,
  CardFieldMountOptions,
  FieldName,
  FieldStyle,
  FieldStyleByState,
  IframeTheme,
  InstallmentPlan,
  InstallmentsCard,
  InstallmentsError,
  InstallmentsResult,
  MentaConstructorOptions,
  MentaErrorCode,
};

declare global {
  interface Window {
    Menta: typeof Menta;
  }
}

// Vite `lib.name: 'MentaSDK'` would otherwise expose a namespace object
// (`window.MentaSDK.Menta`); the frozen public surface requires a bare
// `window.Menta` global, so it is assigned explicitly here (design note,
// `src/index.ts`).
if (typeof window !== 'undefined') {
  window.Menta = Menta;
}
